import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const RestreamDestinations = React.lazy(() => import("@mediaspace/features/restream-destinations"));

export const render = getStandaloneComponentRenderer(RestreamDestinations, true);
